import React from 'react';
import './LogInForm.scss';
import Input from '../../Shared/Input/Input';
import { Link } from 'react-router-dom';
const LogInForm=()=>{
    return(
        <div className="loginform">
        <div className="login-container" data-aos="zoom-in"
              data-aos-delay={100}>
            <h1>Welcome Back</h1>
            <p>Enter your details bellow to start Login process...</p>
            <form>
            <Input 
            label="Email"
            type="email"
            forgot="Forgot Email"
            />
            <Input 
            label="Password"
            type="password"
            forgot="Forgot Password"
            />
            <div className="checkpart">
                <div className="remember">
                    <input type="checkbox" />
                    <p>Remember Me</p>
                </div>
                <div className="acc">
                    <p>Don't have an account ? <Link to="sign-up">Get Started</Link></p>
                </div>
            </div>
            <button type="submit">Log In</button>
            </form>
        </div>
        </div>
    )
};
export default LogInForm ;